module.exports = __webpack_public_path__ + "static/media/hero-home-small.7b3a4d3f.svg";